@let site = site$ | async;
@defer (when site) {
    <div class="flex flex-col">
        <h5>Ready for Payment Validation</h5>
        <div [class.hidden]="elevatedAccess() || site.services.kycDocumentation || site.services.readyForPayment">
            No payment validation option selected
        </div>

        @if (elevatedAccess() || site.services.kycDocumentation) {
            <div class="flex flex-col">
                <mds-checkbox
                    [formCtrl]="formGrp().controls.kycDocumentationControl"
                    id="kycDocumentationCheckbox"
                    label="KYC Documentation Required"
                    name="kycDocumentation"
                />
                <span class="ml-4"
                    >A patient form must be uploaded to the Know Your Customer section of the Patient Profile before
                    checking Ready for Payment</span
                >
            </div>
        }

        @if (elevatedAccess() || site.services.readyForPayment) {
            <div class="flex flex-col">
                <mds-checkbox
                    id="readyForPaymentCheckbox"
                    [formCtrl]="formGrp().controls.readyForPaymentControl"
                    label="Ready for Payment Required"
                    name="readyForPayment"
                />

                <span class="ml-4"
                    >Ready for Payment must be checked in the Patient Profile before a payment request can be
                    completed</span
                >
            </div>
        }
    </div>
}
